interface LoaderProps {
  minusLeftSection?: string;
  minusTopSection?: string;
  minusBottomSection?: string;
  minusRightSection?: string;
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
}

export const Loader = ({
  minusLeftSection,
  minusTopSection,
  minusBottomSection,
  minusRightSection,
  position = "fixed",
}: LoaderProps) => {
  return (
    <div
      className="loader-container"
      style={{
        position: position || "fixed",
        top: minusTopSection ? minusTopSection : "50px",
        left: minusLeftSection ? minusLeftSection : 0,
        right: minusRightSection ? minusRightSection : 0,
        bottom: minusBottomSection ? minusBottomSection : 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        zIndex: 9999,
      }}
    >
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div
        className="circular-loader"
        style={{
          width: "50px",
          height: "50px",
          position: "relative",
        }}
      >
        <div
          className="loader-spinner"
          style={{
            border: "4px solid rgba(0, 0, 0, 0.1)",
            borderRadius: "50%",
            borderTop: "4px solid #3b82f6",
            width: "100%",
            height: "100%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
      </div>
      <div
        className="loader-text"
        style={{
          marginTop: "16px",
          color: "#64748b",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        Loading...
      </div>
    </div>
  );
};
